const lang = {
    cancel: '取消',
    close: '關閉',
    ok: '確定',
    country: {
        china: '中國',
        hongKong: '中國香港',
        macau: '中國澳門',
        taiwan: '中國臺灣',
        singapore: '新加坡',
        malaysia: '馬來西亞',
        indonesia: '印度尼西亞',
        thailand: '泰國',
        philippines: '菲律賓',
        vietnam: '越南',
        myanmar: '緬甸'
    },
    friendlyTime: {
        just: '剛剛',
        yesterday: '昨天',
        oneMinuteAgo: '1分鐘前',
        minutesAgo: '分鐘前',
        oneHourAgo: '1小時前',
        hoursAgo: '小時前',
        daysAgo: '天前',
        weeksAgo: '週前',
    },
    loading: '加載中…',
    page: {
        loadMore: '加載更多',
        loading: '正在加載',
        noMore: '沒有更多數據了'
    },
    empty: {
        noData: '暫無數據',
        noAttention: '暫無關注',
        noNetwork: '暫無網絡',
        theServerIsWrong: '服務器出錯了',
        underConstructionAndWorkingHardToMaintain: '正在建設中、正在努力維護中',
        pleaseWaitPatientlyForCertificationAndReview: '認證、審核請耐心等待',
        searchNoResults: '搜索無結果',
    },
    selectMember: {
        all: '全部',
        title: '選擇人員',
        titleRange: '選擇範圍',
        selected: '已選擇',
        search: '搜索',
        clear: '清空',
        cancel: '取消',
        ok: '確定',
        dept: '組織',
        deptMember: '組織成員',
        group: '內部群',
        groupMember: '內部群成員',
        team: '組',
        teamMember: '組內成員',
        member: '成員',
        includingSubordinate: '包含下級',
        cancelSubordinate: '取消下級',
        publicTeam: '公共組',
        privateTeam: '個人組',
    }
}

export default lang


// WEBPACK FOOTER //
// ./src/locale/lang/zh-TW.js